import {CircularProgress, Typography} from '@mui/material'
import React, {useContext, useEffect, useState} from 'react'
import http from '../http'
import {AppContext} from '../contexts/AppContextProvider'
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";
import useRedirect from "../hooks/useRedirect";

export type LoginResponse = { isLoggedIn: boolean, token: string }

const LoginCheck: React.FC = ({children}) => {
    const [valid, setValid] = useState(false)
    const {setLoggedIn} = useContext(AppContext);
    const {t, orgName} = useContext(OrgCustomizationContext)
    const {redirect} = useRedirect()

    useEffect(() => {
        http.get<LoginResponse>(`/api/login`)
            .then(({data}) => {
                if (data.isLoggedIn) {
                    if (data.token) {
                        http.defaults.headers['Authorization'] = 'Bearer ' + data.token
                        localStorage.setItem('token', data.token)
                    }

                    setLoggedIn(true)
                    setValid(true)
                } else {
                    setLoggedIn(false)
                    setValid(true)
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) redirect('login')
                else {
                    setLoggedIn(false)
                    setValid(true)
                }
            })

    }, [redirect, setLoggedIn])

    return valid
        ? <> {children} </>
        : <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100vw',
                height: '100vh',
                flexDirection: 'column',
                gap: 30,
            }}
        >
            <Typography variant='h4' color='primary'>
                {orgName} {t('gi_complaints')}
            </Typography>

            <CircularProgress size='3rem'/>

            <p>Loading...</p>
        </div>
}

export default LoginCheck
